import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const searchStyles: {
  textField: SxProps<Theme>;
} = {
  textField: {
    width: '40ch',
    margin: '5pt',
    height: '30pt',
  },
};

export default searchStyles;
